<div data-cy="tax-details">
  <ng-template #modalContentTemplate>
    <div [innerHTML]="taxInformationComponentTextData"></div>
  </ng-template>
  <ng-form [formGroup]="taxForm">
    @if (userFromTaxExemptionCountry || (showTaxIdFieldToggle ? taxIdRequiredForBilling : true)) {
      <h6 role="menuitem"
          class="navigation__medium--l udex-mb-20">{{'checkout.digitalNativeCheckout.tax.taxHeader' | cxTranslate}}
      </h6>
    }
    @if (showTaxIdFieldToggle ? taxIdRequiredForBilling : true) {
      <div>
        <div class="tax-info">
          <udex-text-field
            #taxEntryField
            (input)="updateTaxInfo($event)"
            [attr.data-cy]="'tax-information'"
            [label]="taxTypePlaceholderDescription || ('checkout.digitalNativeCheckout.tax.taxId' | cxTranslate)"
            [valueState]="taxForm.controls.taxId.invalid ?  'Error' : 'Standard'"
            [value]="taxForm.controls['taxId']?.value || ''"
            accessible-name="taxId"
            class="col-12 col-sm-5"
            name="taxId"
          >
          </udex-text-field>
          <div class="form-tooltip">
            <dcp-icon-button-tooltip
              [openOnClick]="true"
              placement="Right"
              id="taxInformationToolTip"
              accessibleName="taxInformationToolTip">
            <span class="body--s text-grey">
              {{
                taxTypeTooltipDescription ?
                  ('checkout.digitalNativeCheckout.tax.errors.taxTooltipFormat' | cxTranslate) + ' ' + taxTypeTooltipDescription
                  : ('checkout.digitalNativeCheckout.tax.taxTooltip' | cxTranslate)
              }}
            </span>
            </dcp-icon-button-tooltip>
          </div>
        </div>
        @if (taxForm.controls.taxId.invalid && !showTaxIdFieldToggle) {
          <div>
            <udex-status-message
              [attr.supporting-text]="'checkout.digitalNativeCheckout.tax.errors.max' | cxTranslate"
              value-state="Error"
              data-cy="tax-id-error"
              class="udex-mb-20">
              id="tax-id-error"
              >
            </udex-status-message>
          </div>
        }
        @if (shouldShowTaxIdValidationError) {
          <div class="col-12 col-sm-5">
            <udex-status-message
              [attr.supporting-text]="taxIdValidationFields.isTaxServerError? ('checkout.digitalNativeCheckout.tax.errors.taxValidationSystem' | cxTranslate):
        ('checkout.digitalNativeCheckout.tax.errors.taxValidation' | cxTranslate) + ' ' + taxTypeTooltipDescription"
              value-state="Error"
              data-cy="tax-id-error"
              class="udex-mb-20">
              >
            </udex-status-message>
          </div>
        }
      </div>
    }
  </ng-form>
  @if (userFromTaxExemptionCountry) {
    <div class="checkbox udex-pt-20">
      <udex-checkbox
        [checked]="isTaxExemptionCheckboxChecked"
        [disabled]="false"
        name="taxExemptionCheckbox"
        data-cy="tax-exemption-checkbox"
        (click)="onTaxExemptionCheckboxChange($event)"
      ></udex-checkbox>
      <label class="tax-info-label body--s">
            <span
              class="form-check-label"> {{'checkout.digitalNativeCheckout.tax.taxExemption' | cxTranslate}} </span>
      </label>
    </div>
    @if (isTaxExemptionCheckboxChecked) {
      <div class="heading__medium--xxs udex-pt-20">
        {{'checkout.digitalNativeCheckout.tax.taxExemptionHeadline' | cxTranslate}}
      </div>
      <div class="udex-pt-8 body--xxs">
        <span
          class="mb-2">{{'checkout.digitalNativeCheckout.tax.fileUploadingInformationWarning1' | cxTranslate}}
          <a
            data-cy="tax-information-link"
            (click)="$event.preventDefault();openExemptionCertificateDetailsModal()"
            href=''>{{'checkout.digitalNativeCheckout.tax.fileUploadingInformationLink' | cxTranslate}}</a>{{'checkout.digitalNativeCheckout.tax.fileUploadingInformationWarning2' | cxTranslate}}</span>
      </div>
      <div class="support-form__input support-form__input-upload input-upload ds-upload udex-pt-12"
           data-cy="tax-file-upload" [ngClass]="{'ds_error': service.isValidationErrorPresent}">
        <div class="ds-upload__block d-sm-flex align-items-center flex-column input-upload-container">
          <input #upload data-test="upload" class="ds-input d-none d-sm-block" type="file"
                 (change)="onFileChange($event)"/>
          <div data-test="upload-placeholder" class="input-upload__placeholder body--l">
            {{'checkout.digitalNativeCheckout.tax.dragDropHere' | cxTranslate}}
          </div>
          <div data-test="upload-placeholder" class="input-upload__placeholder body--s">
            {{'checkout.digitalNativeCheckout.tax.or' | cxTranslate}}
          </div>
          <udex-button size="Large" design="Secondary" data-test="upload-btn" (click)="upload.click()"><span
            class="ds-upload__block__button__text">{{'checkout.digitalNativeCheckout.tax.button' | cxTranslate}}</span>
            <span class="ds-upload__block__button__text--loading">
          <em class="ds-loading-indicator m-r-xs"></em>
          Uploading
        </span>
          </udex-button>
        </div>
      </div>
      @if (service.Attachments.errors) {
        <div>
          @if (service.Attachments.errors.amount) {
            <udex-status-message
              [attr.supporting-text]="'checkout.digitalNativeCheckout.tax.errors.countLimit' | cxTranslate"
              value-state="Error"
            ></udex-status-message>
          }
        </div>
      }
      <div *ngFor="let attachment of service.Attachments.controls; index as i">
        <p [ngClass]="{'ds_error': !!attachment.errors}" class="body--m mt-3 mb-0 tax-exemption-files">
          {{attachment.value.name}}
          <span (click)="onRemoveDocument(i)"
                class="ms-1 btn-link ds-cursor--pointer">
            <udex-control-button
              icon="decline"
              size="Medium"
              design="Default"
              accessible-name="removeTaxExemptionFiles"
              accessible-name-ref="removeTaxExemptionFiles"
              accessible-role="Button"
            ></udex-control-button>
            </span>
        </p>
        @if (attachment.errors) {
          <div>
            @if (attachment.errors.size) {
              <udex-status-message
                [attr.supporting-text]="'checkout.digitalNativeCheckout.tax.errors.fileSize' | cxTranslate"
                value-state="Error"
              ></udex-status-message>
            }
            @if (attachment.errors.fileType) {
              <udex-status-message
                [attr.supporting-text]="'checkout.digitalNativeCheckout.tax.errors.fileType' | cxTranslate"
                value-state="Error"
              ></udex-status-message>
            }
          </div>
        }

      </div>
      @if (service.isFileInfected) {
        <udex-status-message
          [attr.supporting-text]="'checkout.digitalNativeCheckout.tax.errors.fileInfected' | cxTranslate"
          value-state="Error"
        ></udex-status-message>
      }
    }
    @if (showWarningMessage && !service.Attachments.errors) {
      <udex-status-message
        [attr.supporting-text]="'checkout.digitalNativeCheckout.tax.warnings.noAttachments' | cxTranslate"
        value-state="Error"
      ></udex-status-message>
      <div class="mb-5"></div>
    }
  }
</div>
